import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE, ERROR_MESSAGES } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { BusinessStore } from 'src/model/business/business-store';
import { Company, SqlInfo } from 'src/model/company.model';
import { CompanyService } from 'src/services/company.service';

@Component({
	selector: 'app-update-company',
	templateUrl: './update-company.component.html',
	styleUrls: ['./update-company.component.scss'],
	providers: [DatePipe],
	standalone: false
})
export class UpdateCompanyComponent implements OnInit {
	private activeModal = inject(NgbActiveModal);
	protected sharedService = inject(SharedService);
	private companyService = inject(CompanyService);
	private businessStore = inject(BusinessStore);

	@Input() companyId: number;

	company: Company = new Company();
	oldRequireConsentForm = false;
	businessId = signal<number>(undefined);
	branchId = signal<number>(undefined);
	sqlInfo: SqlInfo = new SqlInfo();

	@Output() passEntry = new EventEmitter<any>();

	async ngOnInit() {
		this.getCompanyDetails(this.companyId);
		this.sqlInfo = await this.companyService.getCompanySQLInfo(this.companyId);
	}

	async getCompanyDetails(companyID: number) {
		this.company = await this.companyService.getCompanyDetails(companyID);
		this.oldRequireConsentForm = this.company.RequireConsentForm;
		this.branchId.set(this.company.BranchId);
		this.businessId.set(this.businessStore.branchBusinessIdMap().get(this.company.BranchId));
	}

	validateFields() {
		const errors: string[] = [];
		if (this.company.CompanyCode == null || this.company.CompanyCode === '') errors.push(ERROR_MESSAGES.EMPTY_FIELD('Company Code'));
		if (this.businessId() == null || this.branchId() == null) errors.push(ERROR_MESSAGES.EMPTY_SELECTION('Branch'));
		if (this.company.DateOperating == null) errors.push(ERROR_MESSAGES.EMPTY_FIELD('Date Operating'));
		return errors;
	}

	submit() {
		const errors = this.validateFields();
		if (errors.length > 0) this.sharedService.openAlert(errors.map(e => `- ${e}`).join('\n'), ALERT_TYPE.DANGER);
		else this.updateCompany();
	}

	async updateCompany() {
		this.company.BranchId = this.branchId();
		const company = await this.companyService.updateCompany(this.company);
		if (this.sqlInfo != undefined) {
			var sqlInfo = await this.companyService.updateSQLInfo(this.company.ID, this.sqlInfo);
		}

		this.passEntry.emit(company);
		this.reset();
		this.sharedService.openAlert('Successfully updated company!', ALERT_TYPE.SUCCESS);
	}

	reset() {
		this.activeModal.close();
	}
}
